/** The member app's API client and query client (04-architecture § 8). */

import { createApiClient } from '@cowoo/shared';
import { env } from '../env';
import { useSessionStore } from './session';

let unauthorizedPending = false;

export const api = createApiClient({
  baseUrl: env.API_BASE_URL,
  appInfo: { app: 'member', version: env.APP_VERSION, platform: 'web' },
  getToken: () => useSessionStore.getState().token,
  onUnauthorized: () => {
    // § 8.3 — debounced, runs once: clear the token, drop the cache, go to login.
    if (unauthorizedPending) return;
    unauthorizedPending = true;
    setTimeout(() => {
      unauthorizedPending = false;
    }, 5000);
    useSessionStore.getState().clear();
  },
});
